<div #videoContainer class="player-container" aria-label="Video player">
  <div *ngIf="!isVideoEnded" class="video-wrapper">
    <div id="videoPlayer" class="video-player" style="width: 100%; height: 100%"></div>
  </div>
</div>
